var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.version,{tag:"component",staticClass:"header shadow",model:{value:(_vm.isMenuActive),callback:function ($$v) {_vm.isMenuActive=$$v},expression:"isMenuActive"}})
}
var staticRenderFns = []

export { render, staticRenderFns }